/* eslint-disable quotes */
import component from './component'
import resources from './resources'

const thaiMessages = {
  component: {
    ...component,
  },
  ra: {
    action: {
      add_filter: 'เพิ่มตัวกรอง',
      add: 'เพิ่ม',
      back: 'ย้อนกลับ',
      bulk_actions: '%{smart_count} รายการถูกเลือก',
      cancel: 'ยกเลิก',
      clear_input_value: 'Clear value',
      clone: 'Clone',
      confirm: 'ยืนยัน',
      create: 'สร้าง',
      create_item: 'สร้าง %{item}',
      delete: 'ลบ',
      edit: 'แก้ไข',
      export: 'รายงาน',
      list: 'รายการ',
      preview: 'ตัวอย่าง',
      refresh: 'รีเฟรช',
      remove_filter: 'ลบตัวกรอง',
      remove: 'Remove',
      save: 'บันทึก',
      search: 'ค้นหา',
      select_all: 'เลือกทั้งหมด',
      select_row: 'Select this row',
      show: 'แสดง',
      sort: 'เรียง',
      undo: 'ย้อนกลับ',
      unselect: 'Unselect',
      upload: 'อัพโหลด',
      expand: 'Expand',
      close: 'Close',
      open_menu: 'Open menu',
      close_menu: 'Close menu',
      update: 'Update',
      move_up: 'Move up',
      move_down: 'Move down',
      open: 'Open',
      toggle_theme: 'Toggle Theme',
      resend: 'Resend',
      // save_and_approve: 'อนุมัติพร้อมบันทึก',
      save_and_approve: 'บันทึก',
      revoke_approval: 'เพิกถอนการอนุมัติ',
      publish: 'เผยแพร่',
      save_and_publish: 'บันทึกพร้อมเผยแพร่',
      unpublish: 'ยกเลิกการเผยแพร่',
      apply_english: 'ใช้เนื้อหาภาษาไทยสำหรับภาษาอังกฤษด้วย',
    },
    boolean: {
      true: 'ใช่',
      false: 'ไม่',
      null: ' ',
    },
    page: {
      create: 'สร้าง %{name}',
      dashboard: 'แดชบอร์ด',
      edit: 'แก้ไข %{name} #%{id}',
      error: 'Something went wrong',
      list: '%{name}',
      loading: 'กรุณารอสักครู่',
      not_found: 'ไม่พบรายการ',
      show: 'แสดง %{name} #%{id}',
      empty: 'No %{name} yet.',
      invite: 'Do you want to add one?',
    },
    input: {
      file: {
        upload_max_file_reach: 'เลือกไฟล์ครบตามไฟล์สูงสุดที่กำหนดแล้ว',
        upload_several: 'ลากไฟล์ที่จะอัพโหลดมาที่นี่ หรือคลิกเพื่อเลือกไฟล์',
        upload_single: 'ลากไฟล์ที่จะอัพโหลดมาที่นี่ หรือคลิกเพื่อเลือกไฟล์',
      },
      image: {
        upload_several: 'ลากไฟล์รูปที่จะอัพโหลดมาที่นี่ หรือคลิกเพื่อเลือกรูป',
        upload_single: 'ลากไฟล์รูปที่จะอัพโหลดมาที่นี่ หรือคลิกเพื่อเลือกรูป',
      },
      references: {
        all_missing: 'Unable to find references data.',
        many_missing:
          'At least one of the associated references no longer appears to be available.',
        single_missing: 'Associated reference no longer appears to be available.',
      },
      password: {
        toggle_visible: 'แสดงรหัสผ่าน',
        toggle_hidden: 'ซ่อนรหัสผ่าน',
      },
    },
    message: {
      about: 'About',
      are_you_sure: 'Are you sure?',
      edit_mode: 'เข้าสู่โหมดการแก้ไขข้อมูล',
      bulk_delete_content:
        'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
      bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name}',
      bulk_update_content:
        'คุณแน่ใจหรือไม่ว่าจะทำการแก้ไขรายการนี้ |||| Are you sure you want to update these %{smart_count} items?',
      bulk_update_title: 'แก้ไขรายการ |||| Update %{smart_count} %{name}',
      bulk_create_content:
        'คุณแน่ใจหรือไม่ว่าจะทำการสร้างรายการนี้ |||| Are you sure you want to create these %{smart_count} items?',
      bulk_create_title: 'สร้างรายการ |||| Create %{smart_count} %{name}',
      confirmation: {
        approve: {
          // title: 'บันทึกและอนุมัติ',
          // content: 'คุณแน่ใจหรือไม่ว่าจะทำการบันทึกและอนุมัติรายการนี้',
          title: 'บันทึก',
          content: 'คุณแน่ใจหรือไม่ว่าจะทำการบันทึกรายการนี้',
        },
        revoke_approve: {
          title: 'ยกเลิกคำอนุมัติ',
          content: 'คุณแน่ใจหรือไม่ว่าจะทำการยกเลิกคำอนุมัติสำหรับรายการนี้ และ กลับสู่สถานะร่าง',
        },
        publish: {
          title: 'เผยแพร่',
          content: 'คุณแน่ใจหรือไม่ว่าจะทำการเผยแพร่รายการนี้',
        },
        save_and_publish: {
          title: 'บันทึกและเผยแพร่',
          content: 'คุณแน่ใจหรือไม่ว่าจะทำการบันทึกและเผยแพร่รายการนี้',
        },
        unpublish: {
          title: 'ยกเลิกผยแพร่',
          content:
            'คุณแน่ใจหรือไม่ว่าจะทำการยกเลิกการเผยแพร่สำหรับรายการนี้ และ กลับสู่สถานะอนุมัติ',
        },
      },
      delete_content: 'Are you sure you want to delete this item?',
      delete_title: 'Delete %{name} #%{id}',
      details: 'Details',
      error: "A client error occurred and your request couldn't be completed.",
      invalid_form: 'กรุณากรอกข้อมูลให้ครบถ้วน',
      loading: 'The page is loading, just a moment please',
      no: 'No',
      not_found: 'Either you typed a wrong URL, or you followed a bad link.',
      yes: 'Yes',
      unsaved_changes: "Some of your changes weren't saved. Are you sure you want to ignore them?",
      forgot_password_message:
        'Please enter the email address associated with your account and We will email you a link to reset your password.',
      reset_password_link_sended:
        'Please check your email and click on the provided link to reset your password.',
      login_title: 'Sign in to backoffice',
      login_sub_title: 'Enter your details below.',
      login_greeting: 'Hi, Welcome Back',
      reset_password: 'Reset Password',
      reset_password_message: 'Please enter the new password in both fields',
      apply_english: 'ใช้เนื้อหาภาษาไทยสำหรับเนื้อหาภาษาอังกฤษแล้ว.',
    },
    navigation: {
      no_results: 'ไม่พบผลลัพธ์การค้นหา',
      no_more_results: 'The page number %{page} is out of boundaries. Try the previous page.',
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_begin: 'Cannot go before page 1',
      page_range_info: 'รายการที่ %{offsetBegin}-%{offsetEnd} จากทั้งหมด %{total}',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}',
      current_page: 'Page %{page}',
      page: 'Go to page %{page}',
      first: 'Go to first page',
      last: 'Go to last page',
      next: 'Go to next page',
      previous: 'Go to previous page',
      page_rows_per_page: 'จำนวนรายการต่อหน้า:',
      skip_nav: 'Skip to content',
    },
    sort: {
      sort_by: 'Sort by %{field} %{order}',
      ASC: 'ascending',
      DESC: 'descending',
    },
    auth: {
      auth_check_error: 'Please login to continue',
      permission_not_found: 'ไม่พบข้อมูลสิทธิ์อนุญาตของคุณ',
      user_menu: 'โปรไฟล์',
      username: 'Username',
      password: 'Password',
      email: 'อีเมล',
      forgot_password: 'ลืมรหัสผ่าน?',
      send_request: 'ส่งคำขอ',
      sign_in: 'เข้าสู่ระบบ',
      sign_in_error: 'Authentication failed, please retry',
      logout: 'ออกจากระบบ',
    },
    notification: {
      updated: 'รายการถูกแก้ไข |||| %{smart_count} รายการถูกแก้ไข',
      order_updated: 'ลำดับของรายการถูกแก้ไข',
      created: 'รายการถูกสร้างขึ้น',
      deleted: 'รายการถูกลบ |||| %{smart_count} รายการถูกลบ',
      bad_item: 'รายการไม่ถูกต้อง',
      item_doesnt_exist: 'ไม่พบรายการนี้',
      http_error: 'Server communication error',
      data_provider_error: 'dataProvider error. Check the console for details.',
      i18n_error: 'Cannot load the translations for the specified language',
      canceled: 'Action cancelled',
      logged_out: 'Your session has ended, please reconnect.',
      not_authorized: "You're not authorized to access this resource.",
      send_request_success: 'ส่งคำขอเสร็จสิ้น',
      saving_password: 'กำลังบันทึกรหัสผ่าน',
      change_password_success: 'เปลี่ยนรหัสผ่านสำเร็จ',
      update_profile_success: 'อัพเดทข้อมูลส่วนตัวสำเร็จ',
      update_admin_success: 'อัพเดทข้อมูลผู้ดูแลระบบสำเร็จ',
      create_admin_success: 'เพิ่มผู้ดูแลระบบสำเร็จ',
      file_size_exceed_error: 'ขนาดไฟล์ที่เลือกมีขนาดใหญ่กว่าที่กำหนด',
      file_count_exceed_error: 'จำนวนไฟล์เกินกว่ากำหนด',
      file_invalid_type_error: 'รูปแบบไฟล์ไม่รองรับ',
      admin_not_found: 'ไม่พบอีเมลนี้',
      link_invalid: 'ลิงก์ไม่ถูกต้องหรือหมดอายุแล้ว กรุณาส่งคำขอใหม่อีกครั้ง',
      not_found: 'ไม่พบข้อมูล',
    },
    map: {
      mapload_load_error: 'เกิดข้อผิดพลาดในการแสดงผลแผนที่',
      autocomplete_load_error: 'ไม่พบรายการที่ค้นหา',
    },
    validation: {
      required: 'กรุณากรอกข้อมูล',
      minLength: 'ต้องมีอย่างน้อย %{min} ตัวอักษร',
      maxLength: 'ต้องมีไม่เกิน %{max} ตัวอักษร',
      minValue: 'Must be at least %{min}',
      maxValue: 'Must be %{max} or less',
      number: 'กรุณากรอกตัวเลข',
      email: 'กรุณากรอก Email',
      oneOf: 'ต้องเป็นหนึ่งใน : %{options}',
      regex: 'Must match a specific format (regexp): %{pattern}',
      data_not_match: 'ข้อมูลไม่ตรงกัน',
      invalid_same_date: 'วันที่ไม่สามารถตรงกัน',
      invalid_after_date: 'วันที่ไม่สามารถเป็นวันที่ในอดีตได้',
      invalid_before_date: 'วันที่ไม่สามารถเป็นวันที่ในอนาคตได้',
      invalid_latitude: 'พิกัดละติจูดไม่ถูกต้อง',
      invalid_longitude: 'พิกัดลองจิจูดไม่ถูกต้อง',
      invalid_current_password: 'รหัสผ่านของคุณไม่ถูกต้อง.',
      invalid_phone_number: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
      invalid_email: 'อีเมลไม่ถูกต้อง',
      password_min_length: 'รหัสผ่านจะต้องมีอย่างน้อย 8 ตัวอักษร',
      password_pattern: 'รหัสผ่านต้องประกอบด้วยตัวอักษรพิมพ์ใหญ่ ตัวพิมพ์เล็ก และตัวเลข',
      password_not_match: 'รหัสผ่านและการยืนยันรหัสผ่านของคุณไม่ตรงกัน',
      update_profile_fail: 'อัพเดทโปรไฟล์ไม่สำเร็จ',
      update_admin_fail: 'อัพเดทข้อมูลผู้ดูแลระบบไม่สำเร็จ',
      create_admin_fail: 'เพิ่มผู้ดูแลระบบไม่สำเร็จ',
      duplicate_phone_number: 'มีเบอร์โทรศัพท์นี้อยู่แล้ว',
      min_upload: 'กรุณาเลือกอย่างน้อย 1 ไฟล์',
      thumbnail_required: 'กรุณาเพิ่มรูปภาพ',
    },
    saved_queries: {
      label: 'Saved queries',
      query_name: 'Query name',
      new_label: 'Save current query...',
      new_dialog_title: 'Save current query as',
      remove_label: 'Remove saved query',
      remove_label_with_name: 'Remove query "%{name}"',
      remove_dialog_title: 'Remove saved query?',
      remove_message: 'Are you sure you want to remove that item from your list of saved queries?',
      help: 'Filter the list and save this query for later',
    },
  },
  resources: {
    ...resources,
  },
}
export default thaiMessages
